import { render, staticRenderFns } from "./PageDemoAudience.vue?vue&type=template&id=56dbaf47&"
import script from "./PageDemoAudience.vue?vue&type=script&lang=js&"
export * from "./PageDemoAudience.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports